<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <transition :enter-active-class="md.mobile() ? '' : 'animated fadeInRight'" appear>
    <div class="TokCategoryCarousel mt-70">
      <div class="TokCategoryCarousel__head">
        <div class="TokCategoryCarousel__head__title">Featured</div>
        <!--
        <div v-if="seeAll" class="TokCategoryCarousel__head__seeAll" @click="navigate(category)">{{
          $t('SHOW_CATEGORY_BUTTON_WEB') }}
        </div>
        -->
      </div>
      <div class="TokCategoryCarousel__body largeOnly">
        <flickity
          ref="flickity"
          :options="flickityOptions"
          @disablePlay="disablePlay"
          @enablePlay="enablePlay"
        >
          <div
            class="carousel-cell"
            v-for="video in category.videos"
            :key="video.id"
            :class="`${perPage} ${$store.state.browser.name}`"
          >
            <div
              class="slide__inner"
              :class="`ar${aspectRatio}`"
            >
              <bkg :url="video.cover" width="280" />
              <div
                class="slide__inner__btn"
                @click="play({ id: video.video_id, fullscreen: false, offers: video.offers, router:$router, ga })"
              >
                <span>{{ canSee({ offers: video.offers }) }}</span>
                <!--
                <highlightsBtn
                  v-if="video.video_type == 'smart-highlights'"
                />
                <playBtn v-else />
                -->
                <template
                  v-if="(!me.registered  || (me.registered && !hasActiveOffers)) && !video.requires_offer"
                >
                  <locked :id="video.video_id" :offers="video.offers" :ga="ga" />
                </template>
              </div>
              <!--
              <component class="videoType" :is="video.video_type"></component>
              -->
            </div>
            <div class="slide__title">
              {{ video.title }}
            </div>
          </div>
        </flickity>
      </div>
      <div class="TokCategoryCarousel__body smallOnly">
        <div
          class="carousel-cell"
          style="margin-bottom: 40px;"
          v-for="video in category.videos"
          :key="video.id"
          :class="`${$store.state.browser.name}`"
        >
          <div
            class="slide__inner"
            :class="`ar16_9`"
          >
            <bkg :url="video.cover" />
            <div
              class="slide__inner__btn"
              style="cursor: pointer;"
              @click="play({ id: video.video_id, fullscreen: false, offers: video.offers, router:$router, ga })"
            >
              <span>{{ canSee({ offers: video.offers }) }}</span>
              <!--
              <highlightsBtn
                v-if="video.video_type == 'smart-highlights'"
              />
              <playBtn v-else />
              -->
              <template
                v-if="(!me.registered  || (me.registered && !hasActiveOffers)) && !video.requires_offer"
              >
                <locked :id="video.video_id" :offers="video.offers" :ga="ga" />
              </template>
            </div>
            <!--
            <component class="videoType" :is="video.video_type"></component>
            -->
          </div>
          <div class="slide__title">
            {{ video.title }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import {
  mapMutations,
  mapActions,
  mapState,
  mapGetters,
} from 'vuex';
import slugify from 'slugify';
import md5 from 'md5';
import get from 'lodash.get';
import Flickity from './flickity.vue';
import bkg from './Bkg.vue';
// import playBtn from './glyphs/PlayBtn.vue';
// import highlightsBtn from './glyphs/HighlightsBtn.vue';
// import live from './glyphs/Live.vue';
// eslint-disable-next-line import/no-duplicates
// import smartHighlights from './glyphs/HighlightsBadge.vue';
// eslint-disable-next-line import/no-duplicates
// import playerHighlights from './glyphs/HighlightsBadge.vue';
import locked from './glyphs/LockedGlyph.vue';
// import vod from './glyphs/Vod.vue';

export default {
  name: 'alive-videos',
  props: ['category', 'aspectRatio', 'seeAll', 'ga', 'perPage'],
  components: {
    // playBtn,
    // highlightsBtn,
    Flickity,
    // live,
    // smartHighlights,
    // playerHighlights,
    // vod,
    locked,
    bkg,
  },
  data() {
    return {
      canPlay: true,
      showCarousel: false,
      md5,
    };
  },
  methods: {
    ...mapMutations(['appReady', 'canSee']),
    ...mapActions(['loadCategory', 'playVideoById']),
    play(obj) {
      const redirects = get(this.conf, 'redirectToLanding', []);
      if (redirects.includes(obj.id)) {
        this.$router.push('/negramaro');
        return;
      }
      if (this.canPlay) this.playVideoById(obj);
    },
    disablePlay() {
      this.canPlay = false;
    },
    enablePlay() {
      this.canPlay = true;
    },
    navigate(category) {
      const slug = slugify(category.title);
      this.appReady(false);
      // TODO check if category is already loaded and use the stored version instead
      this.loadCategory(category)
        .then(() => {
          this.$router.push(slug);
        });
    },
  },
  computed: {
    ...mapGetters(['scaleImage']),
    ...mapState(['md', 'me', 'colors', 'conf']),
    flickityOptions() {
      return {
        cellAlign: 'left',
        initialIndex: 0,
        prevNextButtons: this.category.videos.length > 4,
        pageDots: false,
        groupCells: false,
        freeScroll: false,
        contain: true,
        wrapAround: false,
      };
    },
    hasActiveOffers() {
      if (!this.me) return false;
      if (!this.me.active_offers) return false;
      if (!this.me.active_offers.length === 0) return false;
      return true;
    },
  },
};
</script>
<style lang="scss">
.smallOnly {
  @media (min-width: 991px) {
    display: none;
  }
}
.largeOnly {
  @media (max-width: 992px) {
    display: none;
  }
}

.TokCategoryCarousel {
  @for $i from 1 through 20 {
    &:nth-child(#{$i}) {
      animation-delay: 0.2s * $i;
    }
  }
  padding-bottom: 8px;

  &.hasDots {
    padding-bottom: 40px;
  }

  .flickity-button {
    background: rgba(0, 0, 0, 0);
    border-radius: 0;
    transition: all .5s ease;
  }

  .flickity-prev-next-button {
    width: 50px;
    height: 102%;
    background-color: rgba(0, 0, 0, 0);
  }

  .flickity-button-icon {
    opacity: 0;
    fill: white;
  }

  &:hover {
    .flickity-button:hover {
      background-color: rgba(0, 0, 0, .8);

      .flickity-button-icon {
        transform: scale(1.5);
      }
    }

    .flickity-prev-next-button {
      background-color: rgba(0, 0, 0, .5);

      &.previous {
        left: 0;
      }

      &.next {
        right: 0;
      }
    }

    /* icon color */
    .flickity-button-icon {
      opacity: 1;
      transition: all .2s ease;
    }
  }
  /*
  &__body {
    display: flex;
    align-items: center;
    flex-direction: column;

    &__inner {
      width: 100%;
      max-width: 600px;

      .carousel-cell {
        margin-bottom: 60px;
      }
    }
  }
  */
}
.flickity-viewport {
  overflow: visible;
}

.carousel-cell {
  transition: all 0.5s ease;
  // padding: 0 10px;
  .bkg {
    border-radius: 6px;
    box-shadow: 0 0 2px 2px rgba(0,0,0,0.3);
    transition: box-shadow 1s ease-in-out;
  }
  z-index: 1;

  &:hover {
    @media (min-width: 992px) {
      transform: scale(1.05);
    }
    z-index: 100;
    .bkg {
      box-shadow: 0 0 10px 10px rgba(0,0,0,0.5);
    }
  }

  &.mobile {
    padding: 0 5px;
  }
}

.flickity-page-dots .dot {
  background: rgb(66, 209, 209);
}
.mt-70 {
  margin-top: 70px;
}
.TokCategoryCarousel__head__title {
  font-family: Roboto;
  font-size: 26px;
  color: #F9FBFC;
  margin-bottom: 20px;
  font-weight: 400;
}

</style>
